import {
  EKwikUIInputNumberDecimal,
  EKwikUIInputNumberSize
} from "./input-number.definitions";

export const DEFAULT_VALUES = {
  decimal: EKwikUIInputNumberDecimal.NEVER,
  disabled: false,
  focus: false,
  formControlName: "form_control_input_number",
  hintContent: "",
  icon: "",
  id: "input_number",
  invalid: false,
  label: "Input Number",
  max: Infinity,
  min: -Infinity,
  placeholder: "Please enter number",
  postfix: "",
  precision: 2,
  prefix: "",
  size: EKwikUIInputNumberSize.L
};

export const VALIDATE_KEY_VALUES = {
  decimal: true,
  disabled: true,
  focus: true,
  formControlName: true,
  hintContent: true,
  icon: true,
  id: true,
  invalid: true,
  label: true,
  max: true,
  min: true,
  placeholder: true,
  postfix: true,
  precision: true,
  prefix: true,
  size: true
};
